export default "__VITE_ASSET__Cg0rry$3__"